<template>
  <div class="wrapper background-primary">
    <!-- <top-navbar></top-navbar> -->
    <content-header></content-header>
    <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
    <content-footer></content-footer>
  </div>
</template>
<style lang="scss">
@font-face {
  font-family: "hiragino-sans-w3";
  src: include("@/fonts/Hiragino-Sans-GB-W3.otf") format("opentype");
}

@font-face {
  font-family: "hiragino-sans-w6";
  src: include("@/fonts/Hiragino-Sans-GB-W6.otf") format("opentype");
}

html,
body {
  //overflow-x: hidden !important;
}

body {
  color: #2d334a !important;
  font-family: "hiragino-sans-w3" !important;
}

.wrapper {
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
}

footer {
  flex-shrink: 0;
}

.background-primary {
  background-color: #fffffe !important;
}

.background-secondary {
  // background-color: #e3f6f5!important;
  background-color: #bae8e8 !important;
}

.background-cautions {
  background-color: #dfdfdf !important;
}

.background-card {
  background-image: linear-gradient(to right, #0087b6, #57bbe3) !important;
}

.background-danger {
  background-image: linear-gradient(to right, #e60517, #e95662) !important;
}

.background-transparent {
  background-color: transparent !important;
}

.button {
  background-color: #ffd803 !important;
  border-color: #ffd803 !important;
  font-family: "hiragino-sans-w6" !important;
}

.headline {
  font-family: "hiragino-sans-w6" !important;
}

.text {
  font-family: "hiragino-sans-w3" !important;
  font-size: 0.75rem !important;
}

.text-bold {
  font-family: "hiragino-sans-w6" !important;
  font-size: 0.85rem !important;
}

.text-color {
  color: #272343 !important;
}

.customs-card {
  border-radius: 1rem !important;
  min-width: 50vw !important;
  width: 500px !important;
  //min-height: 50vh !important;
}

.customs-card .card-footer {
  background-color: transparent !important;
}
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentHeader from "./ContentHeader.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";

export default {
  components: {
    TopNavbar,
    ContentHeader,
    ContentFooter,
    DashboardContent,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
